export default __webpack_public_path__ + "static/media/rambouillet19.12d1fcab.jpg";